//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.DialogsAdeSubradaCiselAkci.ts						</Name>
//    <Description> Funkce pro otev�en� dialog� spojen�ch s �ady ��sel akc� </Description>
//    <Author>      JKLUSACEK													</Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-10-21                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.16.5
//AdtGeneratorConfig:[ T:(srvsdde) GID:(Web.Dia.Ts) V1:(rok,ico,ixs_pla,subrada,nazev,maska,aktivita,dat_zmena,zmenu_prov,cislo_od,cislo_do) V2:() K1:() K2:() K3:() ]

namespace Gordic.Adm.Dialogs {

    // AdeSubradaCiselAkci
    export function DetailAdeSubradaCiselAkciDlg(
        parentContent: GContent,
        opt: {
            /** rok */
            rok: number | null,
            /** ico */
            ico: string | null,
            /** ixs_pla */
            ixs_pla: string | null,
            /** subrada */
            subrada: number | null,
            /** grid jquery element */
            grid?: JQuery<HTMLElement>,
            /** p��znak nov�ho z�znamu */
            newRecord?: boolean
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;
    var detailCommand = opt.grid ? false : true;

    // grid remote control, kv�li �ipk�m na detailu
    const gridRemoteControl = opt && opt.grid ? new Gordic.Components.GridRC(opt.grid) : undefined;

    var detail = ['Gordic.Adm.WebControls.DetailAdeSubradaCiselAkci', { gridRemoteControl: gridRemoteControl }]

    const options = {
        ID: "AdmAdeSubradaCiselAkci#",
        rok: opt ? opt.rok : undefined,
        ico: opt ? opt.ico : undefined,
        ixs_pla: opt ? opt.ixs_pla : undefined,
        subrada: opt ? opt.subrada : undefined,
        newRecord: opt ? opt.newRecord : undefined,
        detailCommand: detailCommand
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
}

    // AdeSubradaCiselAkci
    export function SeznamAdeSubradaCiselAkciDlg(
        parentContent: GContent,
        opt: {
            /** rok */
            rok: number | null,
            /** ico */
            ico: string | null,
            /** ixs_pla */
            ixs_pla: string | null,
            /** subrada */
            subrada: number | null,
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;

    var detail = ['Gordic.Adm.WebControls.SeznamAdeSubradaCiselAkci', { }]

    const options = {
        ID: "AdmAdeSubradaCiselAkci#",
        rok: opt ? opt.rok : undefined,
        ico: opt ? opt.ico : undefined,
        ixs_pla: opt ? opt.ixs_pla : undefined,
        subrada: opt ? opt.subrada : undefined,
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
  }

}
